import React, { useState, useRef, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import Tooltip from '@tippyjs/react';
import { confirmAlert } from "react-confirm-alert";
import 'tippy.js/dist/tippy.css';
import CheckButton from "react-validation/build/button";
import { useForm } from "react-hook-form";
import Form from "react-validation/build/form";

import EditAddressService from "../../../../services/party/address/editAddressServices";
import { getTrans as t } from "../../../../Localization/translations";
import ButtonLoading from "../../../../components/Loder/buttonLoading";
import GetCompanyInfoService from "../../../../services/company/getCompanyInfoService";
import AddresstList from "../../../../components/addressList";
import { API } from "../../../../backend";
import DetailsPartyService from "../../../../services/party/detailsparty";


function EditAddress({ id, address }) {

    const [address_line_1, setAddress_line_1] = useState("")
    const [address_line_2, setAddress_line_2] = useState("")
    const [city, setCity] = useState("")
    const [state, setState] = useState("")
    const [zip_code, setZip_code] = useState("")
    const [country, setCountry] = useState("")
    const [bill_to, setBill_to] = useState("")
    const [ship_to, setShip_to] = useState("")
    const [install_to, setInstall_to] = useState("")
    const [successful, setSuccessful] = useState(false);
    const [loading, setLoading] = useState(false)
    const [country_name, setCountry_name] = useState([])
    const [countryid, setCountryid] = useState("")
    const [state_name, setState_name] = useState([])
    const [stateaddressId, setStateAddressId] = useState("")
    const [attribute, setAttribute] = useState([
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
    ])
    const [hideshowedit, setHideShowEdit] = useState(false)
    const [extrafiledpartyaddress, setExtraFiled] = useState([])


    const [partyType, setPartyType] = useState(null);
    const [partyLoading, setPartyLoading] = useState(true);
    const [partyError, setPartyError] = useState(null);
    const showBillShipInstall = partyType !== "Vendor";

    const checkBtn = useRef();
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const form = useRef();
    const handleCancel = () => {
        setHideShowEdit(true)
    }


    useEffect(() => {
        EditAddressService.getPartyAddressDetails(address).then(
            (response) => {
                setAddress_line_1(response.data.address_line_1)
                setAddress_line_2(response.data.address_line_2)
                setCity(response.data.city)
                setState(response.data.state)
                setZip_code(response.data.zip_code)
                setCountry(response.data.country)
                setBill_to(response.data.bill_to)
                setShip_to(response.data.ship_to)
                setInstall_to(response.data.install_to)
                setAttribute([
                    { attribute: response.data.partyaddressattribute1 },
                    { attribute: response.data.partyaddressattribute2 },
                    { attribute: response.data.partyaddressattribute3 },
                    { attribute: response.data.partyaddressattribute4 },
                    { attribute: response.data.partyaddressattribute5 },
                    { attribute: response.data.partyaddressattribute6 },
                    { attribute: response.data.partyaddressattribute7 },
                    { attribute: response.data.partyaddressattribute8 },
                    { attribute: response.data.partyaddressattribute9 },
                    { attribute: response.data.partyaddressattribute10 },
                    { attribute: response.data.partyaddressattribute11 },
                    { attribute: response.data.partyaddressattribute12 },
                    { attribute: response.data.partyaddressattribute13 },
                    { attribute: response.data.partyaddressattribute14 },
                    { attribute: response.data.partyaddressattribute15 },
                ])
                reset({
                    address_line_1: response.data.address_line_1,
                    address_line_2: response.data.address_line_2,
                    city: response.data.city,
                    zip_code: response.data.zip_code,
                    country: response.data.country,
                    state: response.data.state
                })
            },
        )
    }, [])

    useEffect(() => {
        if (!id) {
            setPartyError("Party ID is missing.");
            setPartyLoading(false);
            return;
        }

        DetailsPartyService.getPartyDetails(id)
            .then((res) => {
                const data = res.data;
                setPartyType(data.party_type);
                setPartyLoading(false);
            })
            .catch((err) => {
                setPartyError("Failed to load party type.");
                setPartyLoading(false);
            });
    }, [id]);

    useEffect(() => {
        if (!showBillShipInstall) {
            setBill_to("No");
            setShip_to("No");
            setInstall_to("No");
        }
    }, [showBillShipInstall]);

    const getExtrafiled = () => {
        GetCompanyInfoService.getExtraFiled().then(
            (response) => {
                setExtraFiled(response.data.existpartyaddress)
            }
        )
    }

    useEffect(() => {
        getExtrafiled()
    }, [])

    const [disable, setDisable] = useState(false)

    const onChangeextrafileds = (e, index) => {
        const { name, value } = e.target
        const rowsInput = [...attribute]
        rowsInput[index][name] = value
        setAttribute(rowsInput)
    }

    const handleRegister = () => {
        setSuccessful(false);
        setLoading(true)
        setDisable(true)
        form.current.validateAll();
        if (checkBtn.current.context._errors.length === 0) {
            if (showBillShipInstall && (bill_to === 'No' && ship_to === 'No' && install_to === 'No')) {
                confirmAlert({
                    title: "",
                    message: "Bill To. Ship To and Install At are not enabled. Do you want to save this address?",
                    buttons: [
                        {
                            label: "Yes",
                            onClick: () => {
                                EditAddressService.editPartyAddressDetails(
                                    address,
                                    address_line_1,
                                    address_line_2,
                                    city,
                                    state,
                                    zip_code,
                                    country,
                                    bill_to,
                                    ship_to,
                                    install_to,
                                    attribute
                                ).then(
                                    (response) => {
                                        if (response.data.success) {
                                            setSuccessful(true);
                                            setLoading(false)
                                            setTimeout(() => {
                                                setHideShowEdit(true)
                                            }, 2000)
                                            toast.success(`${response.data.response}`, {
                                                position: "top-right",
                                                autoClose: 1000,
                                                hideProgressBar: false,
                                                pauseOnHover: true,
                                                draggable: true,
                                                progress: undefined,
                                                theme: "light",
                                            })
                                        }
                                        else {
                                            toast.error(`${response.data.error}`)
                                            setSuccessful(false);
                                            setDisable(false)
                                        }
                                    },
                                )
                            },
                        },
                        {
                            label: "No",
                            onClick: () => {
                                setLoading(false)
                                setDisable(false)
                            }
                        },
                    ],
                });
            } else {
                EditAddressService.editPartyAddressDetails(
                    address,
                    address_line_1,
                    address_line_2,
                    city,
                    state,
                    zip_code,
                    country,
                    bill_to,
                    ship_to,
                    install_to,
                    attribute
                ).then(
                    (response) => {
                        if (response.data.success) {
                            setSuccessful(true);
                            setLoading(false)
                            setTimeout(() => {
                                setHideShowEdit(true)
                            }, 2000)
                            toast.success(`${response.data.response}`, {
                                position: "top-right",
                                autoClose: 1000,
                                hideProgressBar: false,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            })
                        }
                        else {
                            toast.error(`${response.data.error}`)
                            setSuccessful(false);
                            setDisable(false)
                        }
                    },
                )
            }
        }
    }

    const getcountry = async () => {
        const res = await fetch(API + "helper/ajax/load-countries/");
        const getcon = await res.json();
        setCountry_name(await getcon);
        if (country) {
            const getcountryId = getcon.filter((val) => val.name === country);
            if (getcountryId.length > 0) {
                const countryId = getcountryId[0]?.id || null;
                setCountryid(countryId);
            } else {
                console.log('Country ID not found');
            }
        } else {
            console.log('Country is not selected yet');
        }
    }

    const getstate = async () => {
        const resst = await fetch(API + "helper/ajax/load-states/" + countryid + "/");
        const getst = await resst.json();
        setState_name(await getst);
        if (state) {
            const getStateName = getst.filter((val) => val.name === state)
            if (getStateName.length > 0) {
                const stateId = getStateName[0]?.id || null
                setStateAddressId(stateId)
            } else {
                console.log('state ID not found');
            }
        } else {
            console.log('state is not selected yet');
        }
    };

    const handlecountry = (event) => {
        const getcoutryId = event.target.value;
        setCountryid(getcoutryId)
        const countryName = country_name.filter((val) => val.id === parseInt(getcoutryId))
        const getcountryName = countryName[0]?.name || null;
        setCountry(getcountryName);
        reset({
            country_name: getcountryName
        })
    }

    const handlestate = (event) => {
        const getstateId = event.target.value;
        setStateAddressId(getstateId)

        const stateName = state_name.filter((val) => val.id === parseInt(getstateId))
        const getstateName = stateName[0]?.name || null
        setState(getstateName)
        reset({
            state: getstateName
        })
    }

    useEffect(() => {
        getcountry()
    }, [country])

    useEffect(() => {
        getstate();
    }, [countryid]);

    return (
        <>
            {
                hideshowedit === false ?

                    <div className="content container-fluid">
                        <ToastContainer
                            autoClose={1000}
                        />
                        <div className="header ">
                            <h5 className="mb-2 pt-3"> {t('Edit Address')} </h5>
                        </div>
                        <div className="card" role="document">
                            <div className="">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Form role="form text-left"
                                                onSubmit={handleSubmit(handleRegister)}
                                                ref={form}
                                                action="."
                                                method="POST"
                                                id="addPartyForm" >
                                                {(
                                                    <>
                                                        <div className="form-group row">
                                                            <div className="col-md-3">
                                                                <label className="col-form-label required">{t('Address Line 1')}<Tooltip content={t("Address_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                <input
                                                                    value={address_line_1}
                                                                    placeholder={t('Address Line 1')}
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="address_line_1"
                                                                    maxLength="200"
                                                                    id="id_address_line_1"
                                                                    {...register("address_line_1", { onChange: (e) => { setAddress_line_1(e.target.value) }, required: true })}
                                                                />
                                                                <div className="invalid-feedback">
                                                                    {errors.address_line_1?.type === 'required' && "Address is required"}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <label className="col-form-label">{t('Address Line 2')} <Tooltip content={t('Address2_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                <input
                                                                    onChange={(e) => setAddress_line_2(e.target.value)}
                                                                    value={address_line_2}
                                                                    placeholder={t('Address Line 2')}
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="address_line_2"
                                                                    maxLength="200"
                                                                    id="id_address_line_2"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <div className="col-md-3">
                                                                <label className="col-form-label required">{t('Country')} <Tooltip content={t('Country_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                <select
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={countryid}
                                                                    name="country"
                                                                    {...register("country", { onChange: (e) => { handlecountry(e) }, required: true })}
                                                                >
                                                                    <option value="">---{t("Select Country")}---</option>
                                                                    {
                                                                        country_name.map((country, i) =>
                                                                        (
                                                                            <option key={i} value={country.id} >{country.name}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                                <div className="invalid-feedback">
                                                                    {errors.country?.type === 'required' && "Country is required"}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <label className="col-form-label required">{t('State')} <Tooltip content={t('State_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                <select
                                                                    value={stateaddressId}
                                                                    className="form-control"
                                                                    name="state"
                                                                    {...register("state", { onChange: (e) => { handlestate(e) }, required: true })}
                                                                >
                                                                    <option value="">---{t("Select State")}---</option>
                                                                    {
                                                                        state_name.map((resst, i) => (
                                                                            <option key={i} value={resst.id} >{resst.name}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                                <div className="invalid-feedback">
                                                                    {errors.state?.type === 'required' && "State is required"}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <div className="col-md-3">
                                                                <label className="col-form-label required">{t('City')} <Tooltip content={t('City_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                <input
                                                                    value={city}
                                                                    placeholder={t('City')}
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="city"
                                                                    maxLength="100"
                                                                    id="id_city"
                                                                    {...register("city", { onChange: (e) => { setCity(e.target.value) }, required: true })}
                                                                />
                                                                <div className="invalid-feedback">
                                                                    {errors.city?.type === 'required' && "City is required"}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <label className="col-form-label required">{t('Zip Code')} <Tooltip content={t('ZipCode_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                <input
                                                                    value={zip_code}
                                                                    placeholder={t('Zip Code')}
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="zip_code"
                                                                    maxLength="30"
                                                                    id="id_zip_code"
                                                                    onChange={(e) => setZip_code(e.target.value)}
                                                                    {...register("zip_code", { onChange: (e) => { setZip_code(e.target.value) }, required: true })}
                                                                />
                                                                <div className="invalid-feedback">
                                                                    {errors.zip_code?.type === 'required' && "Zip Code is required"}
                                                                </div>
                                                            </div>

                                                        </div>
                                                        {showBillShipInstall && (
                                                            <div className="form-group row">
                                                                <div className="col-md-3">
                                                                    <label className="col-form-label">{t('Bill To')} <Tooltip content={t('BillTo_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                    <div className="form-group row">
                                                                        <div className="form-check" style={{ width: "25%", paddingLeft: "2.73em" }}>
                                                                            <input className="form-check-input" value="Yes" checked={bill_to === "Yes"} type="radio" name="bill_to" id="flexRadioDefault1"
                                                                                onChange={(e) => setBill_to(e.target.value)} />
                                                                            <label className="form-check-label" htmlFor="flexRadioDefault1">
                                                                                Yes
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check" style={{ width: "25%", paddingLeft: "2.73em" }}>
                                                                            <input className="form-check-input" value="No" checked={bill_to === "No"} type="radio" name="bill_to" id="flexRadioDefault1"
                                                                                onChange={(e) => setBill_to(e.target.value)} />
                                                                            <label className="form-check-label" htmlFor="flexRadioDefault1">
                                                                                No
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <label className="col-form-label">{t('Ship To')} <Tooltip content={t('ShipTo_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                    <div className="form-group row">
                                                                        <div className="form-check" style={{ width: "25%", paddingLeft: "2.73em" }}>
                                                                            <input className="form-check-input" value="Yes" checked={ship_to === "Yes"} type="radio" name="ship_to" id="flexRadioDefault1"
                                                                                onChange={(e) => setShip_to(e.target.value)} />
                                                                            <label className="form-check-label" htmlFor="ship_to">
                                                                                Yes
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check" style={{ width: "25%", paddingLeft: "2.73em" }}>
                                                                            <input className="form-check-input" value="No" checked={ship_to === "No"} type="radio" name="ship_to" id="flexRadioDefault1"
                                                                                onChange={(e) => setShip_to(e.target.value)} />
                                                                            <label className="form-check-label" htmlFor="ship_to">
                                                                                No
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <label className="col-form-label">{t('Install At')} <Tooltip content={t('InstallTo_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                    <div className="form-group row">
                                                                        <div className="form-check" style={{ width: "25%", paddingLeft: "2.73em" }}>
                                                                            <input className="form-check-input" value="Yes" checked={install_to === "Yes"} type="radio" name="install_to" id="flexRadioDefault1"
                                                                                onChange={(e) => setInstall_to(e.target.value)} />
                                                                            <label className="form-check-label" htmlFor="ship_to">
                                                                                Yes
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check" style={{ width: "25%", paddingLeft: "2.73em" }}>
                                                                            <input className="form-check-input" value="No" checked={install_to === "No"} type="radio" name="install_to" id="flexRadioDefault1"
                                                                                onChange={(e) => setInstall_to(e.target.value)} />
                                                                            <label className="form-check-label" htmlFor="ship_to">
                                                                                No
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {
                                                            extrafiledpartyaddress.length === 0 ?
                                                                "" :
                                                                <h4 className="tc mt-4" >{t("Additional Information")} :</h4>
                                                        }
                                                        <div className="form-group row">
                                                            {
                                                                extrafiledpartyaddress.map((key, index) => (
                                                                    <>
                                                                        <div className={key.enable === "True" ? "col-sm-3" : null}>
                                                                            <label style={{ display: key.enable === 'True' ? true : "none" }} className="col-form-label"> {key.label} <Tooltip content={key.label}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                            <input
                                                                                id={"attribute_" + index}
                                                                                style={{ display: key.enable === 'True' ? true : "none" }}
                                                                                value={attribute[index]['attribute'] ? attribute[index]['attribute'] : ""}
                                                                                className="form-control mb-1"
                                                                                name='attribute'
                                                                                type={key.datatype}
                                                                                placeholder={key.label}
                                                                                onChange={(e) => onChangeextrafileds(e, index)}
                                                                            />
                                                                        </div>
                                                                    </>
                                                                ))
                                                            }
                                                        </div>
                                                        <div className="text-left py-3">
                                                            <button type="button" className="btn btn-secondary btn-md" onClick={handleCancel}>{t('Cancel')}</button>&nbsp;
                                                            <button type="submit" disabled={disable} className="border-0 btn btn-primary btn-gradient-primary btn-md">
                                                                {
                                                                    loading === false ? (
                                                                        t('Update')
                                                                    ) : (
                                                                        <ButtonLoading />
                                                                    )
                                                                }
                                                            </button>&nbsp;
                                                        </div>
                                                    </>
                                                )}
                                                <CheckButton style={{ display: "none" }} ref={checkBtn} />
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <AddresstList id={id} />
            }
        </>
    )
}

export default EditAddress;
